// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"587":"fe3d010d","764":"863a05c1"}[chunkId] + ".css";
};